/** Every credit line field the form holds as a number string, so a new line field fails to compile until it is listed or excluded here. */
export const LINE_NUMBER_FIELDS = {
    quantity: true,
    unitPrice: true,
    percentageOff: true,
    customerPaid: true,
};
//# sourceMappingURL=line-number-fields.js.map